import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DataTable from 'react-data-table-component'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { useModuleSettings } from '../../context/adminSettingsContext'
import { hasPermission } from '../../common/permissions'
import Swal from 'sweetalert2'
import { selectGlobalLoading } from '../../store/selectors/loadingSelector'
import { downloadSettlementReport, settlementListing } from '../../apis/apiHandler'
import DateRangePicker from "react-bootstrap-daterangepicker";
import Globals from '../../common/global'
import { exportExcelFile, getCardName } from '../../common/utils'
import { allSettlements } from '../../slice/settlementSlice'

const Settlement = () => {
  const dispatch = useDispatch();
  const { settlementList } = useSelector(state => state.settlement);
  const isLoading = useSelector(selectGlobalLoading);
  const navigate = useNavigate();

  const {
    page,
    setPage,
    limit,
    setLimit,
  } = useModuleSettings();

  console.log("settlementList", settlementList?.data);

  const [statusFilter, setStatusFilter] = useState('')
  const [searchQuery, setSearchQuery] = useState('')
  const [searchDebounce, setSearchDebounce] = useState('')
  const [filters, setFilters] = useState({
    rangDate: {
      start_date: '',
      end_date: '',
    },
  })

  const setDates = (e, { startDate, endDate }) => {
    setFilters((prev) => ({
      ...prev,
      rangDate: {
        start_date: moment(startDate)._i !== 0 ? moment(startDate).format('YYYY-MM-DD') : '',
        end_date: moment(endDate)._i !== 0 ? moment(endDate).format('YYYY-MM-DD') : ''
      },
    }));
  }

  const handleResetFilters = () => {
    setSearchQuery('')
    setStatusFilter('')
    setFilters({ rangDate: { start_date: '', end_date: '' } })
    setPage(1)
  }

  const isAnyFilterActive = searchQuery || statusFilter || filters?.rangDate?.start_date

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchDebounce(searchQuery)
      setPage(1)
    }, 500)

    return () => clearTimeout(timer)
  }, [searchQuery])

  useEffect(() => {
    dispatch(allSettlements({
      page,
      limit,
      status: statusFilter !== 'all' ? statusFilter : undefined,
      search: searchDebounce || undefined,
      date_from: filters?.rangDate?.start_date ?? null,
      date_to: filters?.rangDate?.end_date ?? null,
    }))
  }, [dispatch, page, limit, statusFilter, searchDebounce, filters])

  const handleView = (tutorId) => {
    navigate('/settlement/view', {
      state: { tutorId }
    })
  }

  const columns = [
    {
      name: 'Sr No',
      width: '80px',
      selector: (_, index) =>
        ((settlementList?.paging?.page_no || 1) - 1) * limit + index + 1,
    },
    {
      name: 'Tutor',
      minWidth: '190px',
      cell: row => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img
            src={row?.profile_picture || process.env.PUBLIC_URL + '/assets/avatar.png'}
            alt="tutor"
            onError={(e) => {
              e.currentTarget.onerror = null
              e.currentTarget.src = process.env.PUBLIC_URL + '/assets/avatar.png'
            }}
            style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
          />
          <div>
            <div style={{ fontSize: '13px', fontWeight: '500', color: '#212529' }}>
              {`${row?.name}`.trim() || 'NA'}
            </div>
          </div>
        </div>
      ),
    },
    {
      name: 'Email',
      selector: row => row.email,
      sortable: true,
      minWidth: '200px',
      cell: row => (
        <span style={{ fontWeight: '600', color: '#495057' }}>
          {row.email || 'NA'}
        </span>
      )
    },
    {
      name: 'Amount Settled',
      selector: row =>
        row.total_amount_settled
          ? row.total_amount_settled
          : 0,
      sortable: true,
      minWidth: '200px',
    },
    {
      name: 'Amount Due',
      selector: row =>
        row.total_balance_due
          ? row.total_balance_due
          : 0,
      sortable: true,
      minWidth: '100px',
    },
    {
      name: 'Total Bookings',
      selector: row =>
        row.total_bookings
          ? row.total_bookings
          : 0,
      sortable: true,
      minWidth: '100px',
    },
    {
      name: 'Completed Sessions',
      selector: row =>
        row.total_completed
          ? row.total_completed
          : 0,
      sortable: true,
      minWidth: '150px',
    },
    {
      name: 'Last Settlement Date',
      selector: row =>
        row.last_settlement_date
          ? moment(row.last_settlement_date).local().format('DD MMM YYYY, hh:mm A')
          : 'NA',
      sortable: true,
      minWidth: '200px',
    },
    {
      name: 'Action',
      width: '120px',
      center: true,
      cell: row => (
        <div className="d-flex gap-2 justify-content-center">
          {hasPermission('bookings', 'view') && (
            <button
              className="btn btn-sm btn-outline-primary"
              title="View"
              onClick={() => handleView(row.tutor_id)}
              style={{
                width: '32px',
                height: '32px',
                padding: '0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #dee2e6',
                borderRadius: '4px'
              }}
            >
              <i className="fe-eye" style={{ fontSize: '14px' }} />
            </button>
          )}

          {/* {hasPermission('bookings', 'delete') && row.is_deleted !== 1 && (
            <button
              className="btn btn-sm btn-outline-danger"
              title="Delete"
              onClick={() => handleDelete(row.id)}
              style={{
                width: '32px',
                height: '32px',
                padding: '0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #dc3545',
                borderRadius: '4px'
              }}
            >
              <i className="fe-trash-2" style={{ fontSize: '14px' }} />
            </button>
          )} */}
        </div>
      ),
    },
  ]

  const customStyles = {
    table: {
      style: {
        backgroundColor: '#ffffff',
        borderRadius: '8px',
      },
    },
    headRow: {
      style: {
        backgroundColor: '#f8f9fa',
        borderBottom: '2px solid #dee2e6',
        minHeight: '48px',
      },
    },
    headCells: {
      style: {
        fontSize: '13px',
        fontWeight: '600',
        color: '#495057',
        paddingLeft: '12px',
        paddingRight: '12px',
      },
    },
    cells: {
      style: {
        fontSize: '13px',
        color: '#212529',
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingLeft: '12px',
        paddingRight: '12px',
      },
    },
    rows: {
      style: {
        minHeight: '60px',
        '&:hover': {
          backgroundColor: '#f8f9fa',
          cursor: 'pointer',
        },
      },
      stripedStyle: {
        backgroundColor: '#ffffff',
      },
    },
    pagination: {
      style: {
        borderTop: '1px solid #dee2e6',
        minHeight: '56px',
        fontSize: '13px',
      },
    },
  }

  const handleDownloadExcel = async () => {
    try {
      const request = {
        status: statusFilter !== 'all' ? statusFilter : undefined,
        search: searchDebounce || undefined,
        is_report: true,
      };

      if (filters === 'custom' && filters?.rangDate?.start_date && filters?.rangDate?.end_date) {
        request.date_from = moment(filters.rangDate.start_date).format('YYYY-MM-DD');
        request.date_to = moment(filters.rangDate.end_date).format('YYYY-MM-DD');
      }

      const rData = await downloadSettlementReport(request);

      if (Number(rData.code) === 200) {

        const columns = [
          // Tutor
          { header: 'Tutor ID', key: 'tutor_id', width: 12, horizontal: 'center' },
          { header: 'Tutor Name', key: 'tutor_name', width: 25, horizontal: 'center' },
          { header: 'Tutor Email', key: 'tutor_email', width: 30, horizontal: 'center' },

          // Booking Order
          { header: 'Booking Order ID', key: 'booking_order_id', width: 18, horizontal: 'center' },
          { header: 'Order ID', key: 'order_id', width: 18, horizontal: 'center' },
          { header: 'Session Type', key: 'session_type', width: 18, horizontal: 'center' },
          { header: 'Total Sessions', key: 'total_sessions', width: 16, horizontal: 'center' },
          { header: 'Sessions Used', key: 'sessions_used', width: 16, horizontal: 'center' },
          { header: 'Sessions Completed', key: 'sessions_completed', width: 20, horizontal: 'center' },
          { header: 'Sessions Cancelled', key: 'sessions_cancelled', width: 20, horizontal: 'center' },
          { header: 'Order Payment Status', key: 'order_payment_status', width: 22, horizontal: 'center' },
          { header: 'Order Status', key: 'order_status', width: 16, horizontal: 'center' },
          { header: 'Purchased At', key: 'purchased_at', width: 20, horizontal: 'center' },

          // People
          { header: 'Parent Name', key: 'parent_name', width: 25, horizontal: 'center' },
          { header: 'Parent Email', key: 'parent_email', width: 30, horizontal: 'center' },
          { header: 'Student Name', key: 'student_name', width: 25, horizontal: 'center' },

          // Financials
          { header: 'Gross Amount', key: 'gross_amount', width: 16, horizontal: 'center' },
          { header: 'Transaction Fee', key: 'transaction_fee', width: 18, horizontal: 'center' },
          { header: 'Admin Fee', key: 'admin_fee', width: 14, horizontal: 'center' },
          { header: 'Total Net Amount', key: 'total_net_amount', width: 18, horizontal: 'center' },
          { header: 'Per Session Net Price', key: 'per_session_net_price', width: 22, horizontal: 'center' },
          { header: 'Net Amount Earned', key: 'net_amount_earned', width: 20, horizontal: 'center' },
          { header: 'Balance Due', key: 'balance_due', width: 14, horizontal: 'center' },
          { header: 'Currency', key: 'currency', width: 10, horizontal: 'center' },

          // Settlement Record
          { header: 'Settlement ID', key: 'settlement_id', width: 16, horizontal: 'center' },
          { header: 'Sessions Settled', key: 'sessions_settled', width: 18, horizontal: 'center' },
          { header: 'Amount Settled', key: 'amount_settled', width: 16, horizontal: 'center' },
          { header: 'Payment Mode', key: 'payment_mode', width: 18, horizontal: 'center' },
          { header: 'Reference Number', key: 'reference_number', width: 20, horizontal: 'center' },
          { header: 'Settlement Notes', key: 'settlement_notes', width: 25, horizontal: 'center' },
          { header: 'Settlement Status', key: 'settlement_status', width: 20, horizontal: 'center' },
          { header: 'Settlement Paid At', key: 'settlement_paid_at', width: 22, horizontal: 'center' },
        ];

        const ExportData = rData.data.map((row) => ({
          // Tutor
          tutor_id: row.tutor_id ?? '-',
          tutor_name: row.tutor_name || '-',
          tutor_email: row.tutor_email || '-',

          // Booking Order
          booking_order_id: row.booking_order_id ?? '-',
          order_id: row.order_id || '-',
          session_type: row.session_type
            ? row.session_type.replace(/_/g, ' ').toUpperCase()
            : '-',
          total_sessions: row.total_sessions ?? '-',
          sessions_used: row.sessions_used ?? '-',
          sessions_completed: row.sessions_completed ?? '-',
          sessions_cancelled: row.sessions_cancelled ?? '-',
          order_payment_status: row.order_payment_status
            ? row.order_payment_status.replace(/_/g, ' ').toUpperCase()
            : '-',
          order_status: row.order_status
            ? row.order_status.replace(/_/g, ' ').toUpperCase()
            : '-',
          purchased_at: row.purchased_at && row.purchased_at !== 'N/A'
            ? moment(row.purchased_at).format('YYYY-MM-DD HH:mm')
            : '-',

          // People
          parent_name: row.parent_name || '-',
          parent_email: row.parent_email || '-',
          student_name: row.student_name || '-',

          // Financials
          gross_amount: row.gross_amount ?? '-',
          transaction_fee: row.transaction_fee ?? '-',
          admin_fee: row.admin_fee ?? '-',
          total_net_amount: row.total_net_amount ?? '-',
          per_session_net_price: row.per_session_net_price ?? '-',
          net_amount_earned: row.net_amount_earned ?? '-',
          balance_due: row.balance_due ?? '-',
          currency: row.currency || 'AED',

          // Settlement Record
          settlement_id: row.settlement_id ?? '-',
          sessions_settled: row.sessions_settled ?? '-',
          amount_settled: row.amount_settled ?? '-',
          payment_mode: row.payment_mode && row.payment_mode !== 'N/A'
            ? row.payment_mode.replace(/_/g, ' ').toUpperCase()
            : '-',
          reference_number: row.reference_number && row.reference_number !== 'N/A'
            ? row.reference_number
            : '-',
          settlement_notes: row.settlement_notes && row.settlement_notes !== 'N/A'
            ? row.settlement_notes
            : '-',
          settlement_status: row.settlement_status
            ? row.settlement_status.replace(/_/g, ' ').toUpperCase()
            : '-',
          settlement_paid_at: row.settlement_paid_at && row.settlement_paid_at !== 'N/A'
            ? moment(row.settlement_paid_at).format('YYYY-MM-DD HH:mm')
            : '-',
        }));

        const fileName = `Settlement_Report_${moment().format('DDMMYYYYHmmss')}`;
        exportExcelFile(columns, ExportData, fileName);

        Swal.fire({
          icon: 'success',
          title: 'Downloaded',
          text: 'Settlement report downloaded successfully',
          timer: 1500,
          showConfirmButton: false,
        });

      } else {
        Swal.fire({ icon: 'error', title: 'Failed', text: rData?.message });
      }

    } catch (error) {
      console.error(error);
      Swal.fire({ icon: 'error', title: 'Failed', text: 'Something went wrong!' });
    }
  };

  return (
    <div className="container-fluid px-4 py-3">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0 fw-semibold">Settlements</h4>
      </div>

      {/* Search and Filter */}
      <div className="card border-0 shadow-sm mb-3" style={{ borderRadius: '8px' }}>
        <div className="card-body p-3">
          <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">

            {/* Left: Search */}
            <div className="position-relative">
              <i
                className="fe-search position-absolute"
                style={{
                  left: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#6c757d',
                  fontSize: '16px'
                }}
              />
              <input
                type="text"
                className="form-control"
                placeholder="Search by name, email..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{
                  paddingLeft: '38px',
                  paddingRight: searchQuery ? '38px' : '12px',
                  height: '40px',
                  minWidth: '400px',
                  fontSize: '14px',
                  border: '1px solid #dee2e6',
                  borderRadius: '6px'
                }}
              />
              {searchQuery && (
                <button
                  className="btn btn-link position-absolute p-0"
                  type="button"
                  onClick={() => setSearchQuery('')}
                  style={{
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#6c757d'
                  }}
                >
                  <i className="fe-x" style={{ fontSize: '16px' }}></i>
                </button>
              )}
            </div>

            {/* Right: Filter dropdown + Download Report */}
            <div className="d-flex align-items-center gap-2">

              {/* Status Filter */}
              {/* <select
                className="form-select"
                value={statusFilter}
                onChange={(e) => {
                  setStatusFilter(e.target.value)
                  setPage(1)
                }}
                style={{
                  height: '40px',
                  width: '130px',
                  fontSize: '13px',
                  border: '1px solid #dee2e6',
                  borderRadius: '6px'
                }}
              >
                <option value="">All Status</option>
                <option value="subscription">From Tutor Subscriptions</option>
                <option value="session">From Parent Booking</option>
              </select> */}

              {/* Date Range Picker for report download */}
              {/* <DateRangePicker
                onApply={setDates}
                initialSettings={{
                  startDate: moment().subtract(6, 'days').format('MM/DD/YYYY'),
                  endDate: moment().format('MM/DD/YYYY'),
                  ranges: Globals.datePickerRanges,
                  autoUpdateInput: false,
                }}
              >
                <input
                  type="text"
                  readOnly
                  value={
                    filters?.rangDate.start_date !== '' && filters?.rangDate.end_date !== ''
                      ? moment(filters?.rangDate.start_date).format('MMM DD, YYYY') + ' – ' + moment(filters?.rangDate.end_date).format('MMM DD, YYYY')
                      : 'Select Date Range'
                  }
                  className="form-control"
                  style={{
                    height: '40px',
                    width: '190px',
                    fontSize: '13px',
                    border: '1px solid #dee2e6',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    backgroundColor: '#fff',
                    color: filters?.rangDate.start_date ? '#212529' : '#6c757d',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                />
              </DateRangePicker> */}


              {/* Clear Filters Button */}
              {isAnyFilterActive && (
                <button
                  type="button"
                  className="btn btn-outline-danger d-flex align-items-center gap-1 reset-filter-btn"
                  onClick={handleResetFilters}
                  title="Clear all filters"
                  style={{
                    height: '40px',
                    fontSize: '13px',
                    borderRadius: '6px',
                    whiteSpace: 'nowrap',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                    flexShrink: 0,
                    border: '1px solid #dee2e6',
                    color: '#6c757d',
                  }}
                >
                  <i className="fe-x" style={{ fontSize: '14px' }} />
                  Clear Filters
                </button>
              )}

              {/* Download Report Button */}
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={handleDownloadExcel}
                disabled={isLoading || settlementList?.data?.length === 0}
                style={{
                  height: '40px',
                  fontSize: '13px',
                  borderRadius: '6px',
                  whiteSpace: 'nowrap',
                  paddingLeft: '14px',
                  paddingRight: '14px',
                  flexShrink: 0,
                }}
              >
                {isLoading && settlementList?.data?.length > 0 ? (
                  <>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                  </>
                ) : (
                  <>
                    <i className="ti ti-download" style={{ fontSize: '16px' }} />
                    Download Report
                  </>
                )}
              </button>

            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="card border-0 shadow-sm" style={{ borderRadius: '8px' }}>
        <DataTable
          columns={columns}
          data={settlementList?.data || []}
          pagination
          paginationServer
          paginationTotalRows={settlementList?.paging?.total || 0}
          paginationPerPage={limit}
          paginationDefaultPage={settlementList?.paging?.page_no || 1}
          onChangeRowsPerPage={(newLimit) => {
            setLimit(newLimit)
            setPage(1)
          }}
          onChangePage={(newPage) => setPage(newPage)}
          responsive
          highlightOnHover
          persistTableHead
          progressPending={settlementList?.loading}
          noDataComponent={
            <div className="p-5 text-center">
              <i className="fe-calendar" style={{ fontSize: '48px', color: '#adb5bd' }}></i>
              <h6 className="mt-3 mb-1 text-muted">
                {searchQuery ? 'No bookings found matching your search' : 'No bookings found'}
              </h6>
              <p className="text-muted small mb-0">
                {searchQuery ? 'Try adjusting your search criteria' : 'Bookings will appear here once created'}
              </p>
            </div>
          }
          customStyles={customStyles}

        />
      </div>
    </div>
  )
}

export default Settlement;